export default "__VITE_ASSET__CO1mGYLO__"